'use client';

import clsx from 'clsx';
import ScrollToTopButton from './ScrollToTopButton';
import FloatingFeedbackButton from './FloatingFeedbackButton';

type SiteFloatingActionsProps = {
  className?: string;
};

/** Feedback FAB stacked above scroll-to-top — shared position via `.site-shell-fab-stack`. */
export default function SiteFloatingActions({ className }: SiteFloatingActionsProps) {
  return (
    <div className={clsx('site-shell-fab-stack', className)} aria-label="Page actions">
      <FloatingFeedbackButton className="site-shell-fab site-shell-fab--feedback" />
      <ScrollToTopButton className="site-shell-fab site-shell-fab--scroll" />
    </div>
  );
}
